import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';

module.exports = {
    createFetchParams: startDate => ({
        date: Math.floor(startDate / TIMESTAMP_MULTIPLY)
    }),
    ...storeModuleFactory({
        name:               'iaasVirtualMachinesLast12m',
        endpoint:           endpoints.iaas.globalInfoVirtualMachines,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        transformResultsFn: response => ({
            results: !response.results ? {} : {vcenter: response.results.vcenter.map(item => ({
                period:      item.period,
                vcenterName: item.vcenter_name,
                totalVmOn:   item.total_vm_on,
                totalVmOff:  item.total_vm_off
            })),
            vcloud: response.results.vcloud.map(item => ({
                period:     item.period,
                vdcClient:  item.vdc_name,
                totalVmOn:  item.total_vm_on,
                totalVmOff: item.total_vm_off
            }))
            }})
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/iaasVirtualMachinesLast12m.js